'use client';

import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { JSection } from '@/components/ui/layout';
import { getStaticAssetUrl } from '@/app/lib/utils/static-asset-url';
import TerraImage from './terra-image';

export default function InDepth() {
    const { t } = useTranslation('terra1-in-depth');

    return (
        <JSection
            size="lg"
            padding="md"
            spacing="none"
            className="flex flex-col items-center justify-center bg-black"
        >
            <div className="w-full">
                <div className="relative flex w-full flex-col items-center rounded-[8px] border border-[#575757] bg-[#0D0C13] p-[24px] sm:rounded-[16px] sm:p-[60px]">
                    <div className="absolute bottom-0 left-0 right-0 top-0 z-0 h-full w-full overflow-hidden">
                        <TerraImage
                            alt="frame background"
                            src={getStaticAssetUrl('/terra1/bg-frame.webp')}
                            sizes="100vw"
                            wrapperClassName="h-full w-full"
                            imageClassName="h-auto w-full"
                            skeletonClassName="bg-[#14141A]"
                            style={{
                                width: '100%',
                                height: 'auto',
                            }}
                            width={16} // 这里的宽度和高度只是用于维持宽高比，不是实际尺寸
                            height={9} // 高度应该是你的 GIF 原始宽高比对应的值
                        />
                    </div>

                    <h2
                        className={clsx(
                            'j-h2 z-10 w-full text-left text-white sm:w-3/5 sm:text-center',
                        )}
                    >
                        {t('title')}
                    </h2>
                    <div
                        className={clsx(
                            'j-t1 z-10 mt-[16px] w-full text-left text-[#C8C8C8] sm:mt-[24px] sm:w-[90%] sm:text-center',
                        )}
                    >
                        <h3 className="hidden">{t('subtitle.part1')}</h3>
                        {t('subtitle.part1')}
                        {t('subtitle.part2')}
                    </div>

                    <div className="relative mt-[32px] w-full overflow-hidden rounded-[8px] border border-[#7A7A7A] backdrop-blur-sm sm:mt-[60px] sm:rounded-[16px]">
                        <TerraImage
                            alt={t('frameDescription')}
                            src={getStaticAssetUrl(
                                '/terra1/joinai-terra-1-model-architecture.gif',
                            )}
                            wrapperClassName="h-full w-full"
                            imageClassName="h-auto w-full"
                            skeletonClassName="bg-[#17171C]"
                            style={{
                                width: '100%',
                                height: 'auto',
                            }}
                            unoptimized
                            width={16} // 这里的宽度和高度只是用于维持宽高比，不是实际尺寸
                            height={9} // 高度应该是你的 GIF 原始宽高比对应的值
                        />
                    </div>

                    <div
                        className={clsx(
                            'j-p1 mt-[11px] w-full text-center text-[#787878] sm:mt-[16px]',
                        )}
                    >
                        {t('imageName')}
                    </div>

                    <div
                        className={clsx(
                            'j-t1 mt-[32px] w-full text-left text-[#C8C8C8] sm:mt-[60px]',
                        )}
                    >
                        {t('comment')}
                    </div>
                </div>
            </div>
        </JSection>
    );
}
